import * as React from "react";

function SvgAbSmartly(props, ref) {
  return (
    <svg
      viewBox="2.175 61.877 22 24"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        fill="#1573FF"
        d="M11.462 62.294a3.15 3.15 0 013.133 0l7.72 4.433a3.111 3.111 0 011.567 2.699v8.865a3.108 3.108 0 01-1.567 2.697l-7.72 4.434a3.15 3.15 0 01-3.133 0l-7.72-4.434a3.108 3.108 0 01-1.567-2.697v-8.865c0-1.115.597-2.142 1.567-2.699l7.72-4.433z"
      />
      <path
        fill="#fff"
        d="M21.276 78.19h-1.234l-.115-.015h-.057c-1.963-.316-3.225-2.809-4.117-4.999l-.096-.235c-.2-.496-.384-.987-.557-1.448-.73-1.934-1.257-3.332-1.955-3.332-.457 0-.9.64-1.397 1.973-2.507 6.842-4.293 7.898-5.57 8.056H5.017a.097.097 0 00-.07.031.112.112 0 00-.03.077c0 .027.011.054.03.074a.09.09 0 00.07.032h16.259a.098.098 0 00.072-.032.113.113 0 000-.151.105.105 0 00-.072-.031zm-13.238 0H6.967a3.847 3.847 0 001.071-.73v.73zm2.51 0h-2.31v-.93c.77-.791 1.53-2 2.31-3.672v4.602zm2.488 0h-2.29v-5.038c.4-.871.788-1.853 1.198-2.959.411-1.106.771-1.707 1.097-1.817l-.005 9.814zm2.533-4.91v4.91h-2.334v-9.82c.535.146 1.067 1.558 1.68 3.184.2.545.425 1.128.665 1.707l-.011.019z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgAbSmartly);
